import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-Comparison",
  "use": "icon-Comparison-usage",
  "viewBox": "0 0 1303 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1303 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-Comparison\"><defs><style type=\"text/css\"></style></defs><path d=\"M1210.181818 930.909091H93.090909V46.545455a46.545455 46.545455 0 0 0-93.090909 0v930.90909a46.545455 46.545455 0 0 0 46.545455 46.545455H1210.181818a46.545455 46.545455 0 1 0 0-93.090909zM261.585455 651.636364c9.681455 0 19.456-3.723636 27.368727-11.357091l235.333818-226.676364 228.538182 226.210909a38.912 38.912 0 0 0 58.554182-2.978909l327.866181-391.633454a50.362182 50.362182 0 0 0 9.309091-45.428364 44.032 44.032 0 0 0-30.626909-31.650909 39.377455 39.377455 0 0 0-40.029091 13.591273L777.960727 540.020364 552.587636 316.881455a38.912 38.912 0 0 0-55.389091-0.465455L234.123636 569.809455a49.989818 49.989818 0 0 0-11.915636 51.572363A42.356364 42.356364 0 0 0 261.585455 651.636364z\" p-id=\"10210\" fill=\"#1296db\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/Comparison.svg
// module id = gchp
// module chunks = 148